export default "__VITE_ASSET__CkJGizzx__"